import React, { Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import Button from '../button/Button';
import Filter from '../filter/Filter';
import Table from '../table/Table';
import Alerta from '../alert/Alerta';
import Panel from '../panel/Panel';

class ModalPesquisa extends AbstractComponent {   
    constructor(props) {
        super(props);

        this.state = {
            showFilter: false            
        }
    }   

    fechar() {      
        if(this.state.showFilter) {
            this.setState({showFilter: false});

            return;
        }
                      
        if(this.props.fechar !== undefined) {
            this.props.fechar();
        }
    }    

    styleList(i) {
        if(i === 0)
            return {
                marginBottom: '25px',
                fontWeight: '700'
            };

        return {listStyle: 'circle'}
    }    
        
    styleHeader() {                
        return (this.props.styleHeader === undefined) ? "bg-white" : this.props.styleHeader;
    }

    styleIcon() {
        return (this.props.styleIcon === undefined) ? "" : this.props.styleIcon;
    }

    styleText() {
        return (this.props.styleText === undefined) ? "text-dark" : this.props.styleText;        
    }        

    getHeader() {
        if(this.state.showFilter)
            return 'Filtros';

        return this.props.header;
    }

    getBtnFechar() {
        if(this.state.showFilter)
            return 'Voltar';

        return 'Fechar';
    }    
    
    showComponent() {
        if(!this.props.show)
            return ;

        return (
            <Modal
                className="modal-fullscreen"
                show={this.props.show}
                onHide={() => this.props.fechar()}>

                <Modal.Header className={this.styleHeader()} closeButton>
                    <Modal.Title className={this.styleHeader()}>                                                                        
                        &nbsp; 
                        &nbsp; 
                        
                        {this.getHeader()}                        
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Panel title="Filtro">
                        <Filter
                            filter={this.props.filter}
                            preload={this.props.preloadFilter}
                            defaultFoco={this.props.defaultFocoFilter}

                            onFilterChange={(index, e) => this.props.onFilterChange(index, e)}
                            onFilterButtonClick={() => { this.props.onFilterButtonClick(); this.setState({ showFilter: false })}}
                            onFilterClearClick={() => this.props.onFilterClearClick()}
                        />
                    </Panel>

                    <Table
                        ref={ref => this.table = ref}
                        head={this.props.head}
                        body={this.props.body}
                        
                        cadastro={this.props.cadastro}                        
                        editar={ this.props.editar }
                        link={ this.props.link }       
                        checkAll={this.props.checkAll}                 

                        remover={this.props.remover}                        

                        onCellClick={() => this.props.onCellClick()}
                        onCheck={(index) => this.props.onCheck(index)}
                        onCheckAll={() => this.props.onCheckAll()}
                        route={(route) => this.props.route(route)}    
                        onCallback={(item) => this.props.onCallback(item)}

                        component={ this.props.component }
                    /> 

                    <Alerta
                        exibir={this.props.erroFilter.code !== 0}
                        texto={this.props.erroFilter.message}
                        timeOut={5}

                        onTimeOut={() => this.props.onClearErroFilter()}
                    />
                </Modal.Body> 

                <Modal.Footer>
                    {
                        this.props.callback &&
                        <Button 
                            className="btnCallback"
                            type="button"                                 
                            onClick={() => {this.props.onCallback(this.props.body)}}
                        >
                            <i className="fas fa-exchange-alt"></i> Exportar
                        </Button>
                    }

                    <Button 
                        className="btn btn-danger"
                        type="button"                                 
                        onClick={() => {this.fechar()}}
                    >
                        {this.getBtnFechar()}
                    </Button>
                </Modal.Footer>                                         
            </Modal>           
        )
    }

    render() {
        return (
            <Fragment>                
                {this.showComponent()}            
            </Fragment>
        )
    }
}

ModalPesquisa.defaultProps = {
    textoArray: []
}

export default ModalPesquisa;